import { Button } from 'components'
import styled from 'styled-components'

export const WidgetButton = styled(Button)`
  width: fill-available;
  max-width: 100%;
  letter-spacing: -0.01em;
  margin: 0 20px 50px 20px;
  position: unset;
  bottom: 120px;
`
